<template>
  <div class="breadcrumbs">
    <div class="breadcrumbs__query-wrapper">
      <button
        v-if="searchQuery && searchQuery !== ''"
        class="breadcrumbs__query"
        @click="emptySearchQuery()"
      >
        {{ searchQuery }}
        <span class="breadcrumbs__query--icon">X</span>
      </button>
    </div>
    <div class="breadcrumbs__filters-wrapper">
      <div
        v-for="(value, key) in refinementsToShow"
        :key="`category-key-${key}`"
        class="breadcrumbs__category"
      >
        <p class="breadcrumbs__category--title">
          {{ transformItemTitle(key) }}:
        </p>
        <div class="breadcrumbs__filters">
          <div
            v-for="filter in value"
            :key="`category-filter-value-${filter}`"
            class="breadcrumbs__filter"
          >
            <p class="breadcrumbs__filter--title">{{ filter }}</p>
            <button
              @click="removeFilter(key, filter)"
              class="breadcrumbs__filter--delete"
            >
              X
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Breadcrumbs',
  props: {
    currentContext: {
      type: String,
      required: true,
    },
    currentRefinements: {
      type: Object,
      required: true,
    },
    searchQuery: {
      type: String,
      required: true,
    },
    filterMap: {
      type: Object,
      required: true,
    },
  },
  computed: {
    refinementsToShow() {
      return this.currentRefinements[this.currentContext]
    },
  },
  methods: {
    emptySearchQuery() {
      this.$store.dispatch('search/setQuery', '')
    },
    transformItemTitle(item) {
      return this.filterMap[item] || item
    },
    removeFilter(facet, value) {
      this.$emit('remove-filter', { facet, value })
    },
  },
}
</script>

<style lang="scss">
.breadcrumbs {
  position: absolute;
  top: -15px;
  width: 95%;
  display: flex;
  align-items: center;
  padding: 0 0 10px 0;
  &__query {
    background: var(--light-gray);
    color: var(--white);
    border: none;
    border-radius: 25px;
    font-size: 0.8rem;
    padding: 4px 25px;
    display: flex;
    align-items: center;
    margin: 0 5px 0 0;
    &--icon {
      font-size: 0.7rem;
      font-weight: 700;
      color: var(--black);
      background: var(--orange);
      padding: 0px 5px;
      border-radius: 100%;
      margin: 0 -20px 0 15px;
      &:hover {
        cursor: pointer;
        opacity: 0.8;
      }
    }
  }
  &__category {
    display: flex;
    align-items: center;
    &--title {
      color: var(--white);
      font-family: var(--font-bold);
      text-transform: uppercase;
      font-size: 0.65rem;
      margin: 0 5px 0 0;
    }
  }
  &__filters-wrapper {
    display: flex;
    align-items: center;
  }
  &__filters {
    display: flex;
    align-items: center;
  }
  &__filter {
    color: var(--white);
    display: flex;
    align-items: center;
    background: var(--light-gray);
    color: var(--white);
    border-radius: 25px;
    padding: 4px 10px;
    margin: 0 5px;
    &--title {
      color: var(--white);
      padding: 0;
      margin: 0 5px 0 0;
      font-size: 0.85rem;
    }
    &--delete {
      background: var(--orange);
      color: var(--black);
      border: none;
      border-radius: 100%;
      padding: 0px 4px;
      font-size: 0.5rem;
      font-family: var(--font-bold);
      &:hover {
        cursor: pointer;
        opacity: 0.8;
      }
    }
  }
}
</style>
